import React, { useState } from "react";
import { toggle } from "../../../util/common";
import { WalletItemSSN } from "../../../store/common";
import { DialogComponent } from "../../common/DialogComponent";
import ConfirmDeleteWalletDialog from "../../Dialogs/lostWallet/ConfirmDeleteWalletDialog";
import SocialSecurityCardDialog from "../../Dialogs/lostWallet/SocialSecurityCardDialog";
import { useTranslation } from "react-i18next";

const SocialSecurityCard: React.FunctionComponent<{ requestDataCallback(): void; walletItemSSNs: WalletItemSSN[] }> = (props) => {
    const { t: tLang, i18n: i18nLang } = useTranslation();
    const [deleteWalletDialogIsVisible, setDeleteWalletDialogIsVisible] = useState(false);
    const [socialSecurityCardDialogIsVisible, setSocialSecurityCardDialogIsVisible] = useState(false);
    const [selectedItem, setSelectedItem] = useState({});
   const [socialSecurityCardNumber, setSocialSecurityCardNumber]:any= useState([]);
    const showDeleteWalletDialog = (selectedItem: WalletItemSSN): any => {
        setSelectedItem(selectedItem);
        setDeleteWalletDialogIsVisible(true);
    };

    const closeDeleteWalletDialog = (): any => {
        setDeleteWalletDialogIsVisible(false);
    };

    const showSocialSecurityCardDialog = (selectedItem: WalletItemSSN): any => {
        setSelectedItem(selectedItem);
        setSocialSecurityCardDialogIsVisible(true);
    };

    const closeSocialSecurityCardDialog = (): any => {
        setSocialSecurityCardDialogIsVisible(false);
    };
    const toggleSSNVisibility = (ssn: any) =>{
        if (socialSecurityCardNumber.length > 0) {
            const index = socialSecurityCardNumber.findIndex((element: any) => element.ssn === ssn.ssn);
         if (index >= 0) {
           socialSecurityCardNumber.splice(index, 1);
           setSocialSecurityCardNumber([...socialSecurityCardNumber]);
            } 
         else {
          setSocialSecurityCardNumber([...socialSecurityCardNumber, ssn]);
         }
          } else {
              setSocialSecurityCardNumber([...socialSecurityCardNumber , ssn]);
         }
        
    }
    return (
        <React.Fragment>
            {props.walletItemSSNs &&
                props.walletItemSSNs.map((ssn: WalletItemSSN, index) => (
                    <div className="data-row" key={"social-security-card" + index}>
                        <div className="link-item">
                            <button
                                type="button"
                                aria-expanded="false"
                                className="link-button"
                                id={"social-security-card-" + index}
                                onClick={() => toggle(`social-security-card-${index}-details`, `social-security-card-${index}`)}
                            >
                                <span className="row link-item">
                                    <span className="col-xs col-no-gutter link-text">
                                        <span className="link-title">
                                            <span className="sr-only btn-toggle-status">Show</span> {ssn.firstName + " " + ssn.lastName}
                                        </span>
                                        <span className="link-helper">
                                            <span className="sr-only">Item Type: </span>
                                            {tLang("identityVault.secureStorage.lostWallterWidget.socialSecurityCard.title2")}
                                        </span>
                                    </span>
                                </span>
                            </button>

                            <div className="wallet-details" id={"social-security-card-" + index + "-details"} style={{ display: "none" }}>
                                <div
                                    role="grid"
                                    className="data-grid row-height-xs"
                                    id={"social-security-card-" + index + "-title"}
                                    aria-labelledby={"social-security-card-" + index + "-title"}
                                >
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"social-security-card-" + index + "-ssn"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.socialSecurityCard.label.ssn")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"social-security-card-" + index + "-ssn"}>
                                            {ssn.ssn && socialSecurityCardNumber.findIndex((element: any) => element.ssn === ssn.ssn) < 0 ? `XXX - XX - ${ssn.ssn.substr(ssn.ssn.length - 4)}` : ssn.ssn }
                                            <button
                                                type="button"
                                                className="btn-default btn-icon-only btn-no-padding"
                                                onClick={() => {
                                                   toggleSSNVisibility(ssn);
                                                }}
                                                title={"Show SSN Text"}
                                                style={{marginLeft: '1.25rem'}}
                                            >
                                                <span className="btn-icon">
                                                    <em
                                                        className={`las ${
                                                            socialSecurityCardNumber.findIndex((element: any) => element.ssn === ssn.ssn) < 0 ? "la-eye" : "la-eye-slash"
                                                        }`}
                                                    ></em>
                                                </span>
                                                <span className="btn-text">Show / Hide SSN Text</span>
                                            </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed  row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"social-security-card-" + index + "-first-name"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.socialSecurityCard.label.firstName")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"social-security-card-" + index + "-first-name"}>
                                                {ssn.firstName}
                                            </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"social-security-card-" + index + "-middle-initial"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.socialSecurityCard.label.middleInitial")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"social-security-card-" + index + "-middle-initial"}>
                                                {ssn.middleName}
                                            </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"social-security-card-" + index + "-last-name"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.socialSecurityCard.label.lastName")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"social-security-card-" + index + "-last-name"}>
                                                {ssn.lastName}
                                            </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"social-security-card-" + index + "-suffix"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.socialSecurityCard.label.suffix")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"social-security-card-" + index + "-suffix"}>
                                                {ssn.suffix}
                                            </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"social-security-card-" + index + "-notes"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.socialSecurityCard.label.notes")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"social-security-card-" + index + "-notes"}>
                                                {ssn.notes}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row between-xs margin-top-l">
                                    <div className="col-xs flex-grow-null col-no-gutter"></div>
                                    <div className="col-xs flex-grow-null col-no-gutter">
                                        <ul className="list-reset list-inline">
                                            <li>
                                                <button
                                                    type="button"
                                                    className="btn-default btn-red-outline btn-no-border"
                                                    onClick={() => showDeleteWalletDialog(ssn)}
                                                >
                                                    <span className="btn-icon">
                                                        <em className="las la-trash-alt"></em>
                                                    </span>
                                                    <span className="btn-text">
                                                        {tLang("identityVault.secureStorage.lostWallterWidget.socialSecurityCard.deleteButtonText")}
                                                    </span>
                                                </button>
                                            </li>
                                            <li className="margin-left-xs">
                                                <button
                                                    type="button"
                                                    className="btn-default btn-primary-outline"
                                                    id="edit-credit-card-1"
                                                    onClick={() => showSocialSecurityCardDialog(ssn)}
                                                >
                                                    <span className="btn-icon">
                                                        <em className="las la-edit-alt"></em>
                                                    </span>
                                                    <span className="btn-text">
                                                        {tLang("identityVault.secureStorage.lostWallterWidget.socialSecurityCard.editDetailsButtonText")}
                                                    </span>
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}

            {/* Delete modal*/}
            {deleteWalletDialogIsVisible && (
                <DialogComponent dialogId="dialog-delete-social-security-card-wallet" title="Delete Wallet" closeDialog={closeDeleteWalletDialog}>
                    <ConfirmDeleteWalletDialog
                        requestDataCallback={props.requestDataCallback}
                        closeDialog={closeDeleteWalletDialog}
                        walletItem={selectedItem}
                        itemType="ssn"
                    />
                </DialogComponent>
            )}

            {/* Edit modal*/}
            {socialSecurityCardDialogIsVisible && (
                <DialogComponent
                    dialogId="dialog-edit-social-security-card-wallet"
                    title="Edit Social Security Card Wallet"
                    closeDialog={closeSocialSecurityCardDialog}
                >
                    <SocialSecurityCardDialog
                        requestDataCallback={props.requestDataCallback}
                        closeDialog={closeSocialSecurityCardDialog}
                        walletItem={selectedItem}
                        isNew={false}
                    />
                </DialogComponent>
            )}
        </React.Fragment>
    );
};

export default SocialSecurityCard;
